import { useEffect, useState } from 'react'
import PersonIcon from '@/assets/property-icons/person.svg';
import PersonHouse from '@/assets/property-icons/person-ina-house-icon.svg'
import { useOpeningElementsControllerContext, useUserLanguage } from '@/customHooks';
import { SquareButtonsCard } from '../molecules';
import styled from 'styled-components';
import { OwnerSimpleSelectionList } from './OwnersSimpleSelectionList';
import { useCreatePropertyContext } from '@/customHooks/useCreatePropertyContext';
import { SimpleOwnerProps } from '@/custom-types';
import { OwnerFilters, initialOwnerFilters } from './OwnerFilters';
import { OwnerFilterInput } from '@/graphql/generated';
import { Pagination } from '../molecules';
import { Row, Col } from 'react-grid-system';

const textsData = {
  en: {
    button1: 'Add New Owner',
    button2: 'Owned By Me',
  },
  es: {
    button1: 'Agregar Propietario',
    button2: 'Me pertenece',
  }
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 3rem;
`

export const SelectPropertyOwnerMenu = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const [selectedOwner, setSelectedOwner] = useState<SimpleOwnerProps>()
  const [filters, setFilters] = useState<OwnerFilterInput>(initialOwnerFilters);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentDataCount, setCurrentDataCount] = useState(0);

  const { createOwnerFormModalOpen } = useOpeningElementsControllerContext()

  const buttons = [
    { text: texts.button1, icon: PersonHouse },
    { text: texts.button2, icon: PersonIcon },
  ];

  const { setOwner, setButtonDisabled, setButtonEnabled } = useCreatePropertyContext()

  const onButtonActionHandle = (value: number | null) => {
    switch (value) {
      case null:
        return

      case 0:
        createOwnerFormModalOpen()
        break

      case 1:
        alert('Este boton está momentanemanete desabilitado')
        break

      default:
        throw new Error('On button action option is invalid [SelectPropertyOwnerMenu]')
    }
  }

  const handleFilterChange = (newFilters: OwnerFilterInput) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setFilters({ ...filters, page: page.toString() });
  };

  const showPagination = currentDataCount > 0;

  useEffect(() => {
    if (!selectedOwner) return
    setButtonEnabled()
    setOwner(selectedOwner)
  
  }, [selectedOwner])

  useEffect(() => {
    setButtonDisabled()
  }, [])

  return (
    <Wrapper>
      <Row style={{ width: '100%' }}>
        <Col>
          <OwnerFilters filters={filters} onFilterChange={handleFilterChange} />
        </Col>
      </Row>
      <OwnerSimpleSelectionList
        filters={{ ...filters, page: currentPage.toString() }}
        selected={(owner) => setSelectedOwner(owner)}
        onDataCountChange={setCurrentDataCount}
      />
      {showPagination && (
        <Row style={{ width: '100%' }}>
          <Col>
            <Pagination
              currentPage={currentPage}
              onPageChange={handlePageChange}
              currentDataCount={currentDataCount}
              pageSize={filters.pageSize || null}
            />
          </Col>
        </Row>
      )}
      <p>Add one or more owners and set their ownership percentage</p>
      <SquareButtonsCard
        buttons={buttons}
        onSelected={onButtonActionHandle}
      />
      
    </Wrapper>
  );
};
